import request from '@/utils/request'


export function login(data) {
  return request({
    url: '/index/user/login',
    method: 'post',
    data
  })
}

export function regist(data) {
  return request({
    url: '/index/user/register',
    method: 'post',
    data
  })
}

export function forgetPass(data) {
  return request({
    url: '/index/user/forgetpass',
    method: 'post',
    data
  })
}

export function checkToken(data) {
  return request({
    url: '/index/user/checkToken',
    method: 'post',
    data
  })
}

export function getTotal(data) {
  return request({
    url: '/index/user/getTotal',
    method: 'post',
    data
  })
}
